const Injury = Object.freeze({
    RIGHT_HAND: "Right Hand",
    LEFT_HAND: "Left Hand"
});

export default Injury;
